// Node imports
import { IEvent, delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { WinPresentationController, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";

// Class imports
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";


/**
 * WinPresentationControllerGame class handels the winpresentation for base game.
 * it controls the win frames, symbol animation presentation.
 */
export class WinPresentationControllerGame extends WinPresentationController {

  protected onShowAllFrames(evt: IEvent): void {
    (ingenuity.soundManager as any).playSound(SoundConstantGame.WIN_LINE_SOUND, 1, false, gameConstants.SOUND_LIST_PRELOAD);
    // to-do: write code here to show win frames on spaghtti
    const windata = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
    if (this.paylineView) {
      if (this.model.getIsAutoPlayLeft() && !this.model.getIsBigWin() && !(ingenuity.parserModel as GameParserModel).getHasFreeGamesWin()) {
        dispatcher.fireEvent(SlotEventConstants.SHOW_ALL_FRAMES, {
          callback() {
            //
          },
          callbackScope: this,
          delayTimer: this.model.getDelayForSpaghttiDispaly(),
          winData: windata
        });
      }
      else if ((ingenuity.parserModel as GameParserModel).getHasLineWins()) {
        this.onShowAllFramesComplete();
      }
      else {
        if (this.model.getIsScatterWins()) {
          dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        }
      }
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
    // Play all anim with delay to show stack before static hide.
    if ((ingenuity.parserModel as GameParserModel).getStackSymPresent() && (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0) {
      delayedCall("playAnimDelayForStack", 100, () => {
        killDelayedCall("playAnimDelayForStack");
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
      }, this)
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);

    }
  }

  /**
     * Method to run on onShowAllFrames Completed
     */
  private onShowAllFramesComplete(): void {
    const windata: number[][] = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
    dispatcher.fireEvent(SlotEventConstants.SHOW_ALL_FRAMES, {
      callback() {
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_FRAMES);
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      },
      callbackScope: this,
      delayTimer: this.model.getDelayForSpaghttiDispaly(),
      winData: windata
    });
  }

  protected onStopAllWinAnimation(): void {
    if (this.paylineView) {
      delayedCall(SlotConstants.TimerHidePayline, this.model.getFadeOutTimeWinBox(), function () {
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_SPAGETTI);
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_FRAMES);
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_WIN_PAYLINE);
      }, this);
    }
    dispatcher.fireEvent(SlotEventConstants.STOP_ALL_WIN_ANIMATIONS);
    // dispatcher.off(SlotEventConstants.WIN_CYCLE_COMPLETED, this.onWinCycleCompleted);
  }

  /**
    * Method Ovveride to suspend win presentation and to remove hide alpha call
    */
  protected onSuspendWinPresentation(): void {
    ingenuity.configData.playAllSymbolAnim = true;
    this.suspendSound();
    if (this.paylineView) {
      if (this.model.getIsWin()) {
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_SPAGETTI);
      }
      dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_FRAMES);
      dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_WIN_PAYLINE);
    }
    dispatcher.fireEvent(SlotEventConstants.CLEAR_DATA);
    dispatcher.fireEvent(SlotEventConstants.STOP_ALL_WIN_ANIMATIONS);
    dispatcher.fireEvent(SlotEventConstants.RESET_METERS);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_WIN_TOGGLE_PLAYER_MSG);
    dispatcher.fireEvent(SlotEventConstantsBehavior.RESET_PLAYER_MESSAGES);
    // to empty symbol sound array- that keeps the record whether a symbol win has occured previously
    this.symbolSoundArray = [];
    if (ingenuity.configData.playAllSymbolAnim) {
      dispatcher.fireEvent(eventDispatchers.RESET_TOGGLE_SOUND_COUNTER);
      
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    }
    if (!ingenuity.configData.isForceStopDuringPot) {
      dispatcher.fireEvent(eventDispatchers.RESET_DATA);
    }
    dispatcher.fireEvent(eventDispatchers.HIDE_LARGE_STACK_SYMBOL);
  }

  /**
     * Method to stop sound.
     */
  private suspendSound(): void {
    // if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD)) {
    //   (ingenuity.soundManager as any).stop(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    // }
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FS_WIN_VOICE, gameConstants.SOUND_LIST_POSTLOAD)) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.FS_WIN_VOICE, gameConstants.SOUND_LIST_POSTLOAD);
    }
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.STACK_WIN, gameConstants.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.STACK_WIN, gameConstants.SOUND_LIST_PRELOAD);
    }
  }

  /**
     * Method onStageClicked overrided to update stage click pot conversion animation.
     * @param evt 
     */
  protected onStageClicked(evt: IEvent): void {
    if (ingenuity.configData.stageClickDuringPotConversion) {
      ingenuity.configData.stageClickDuringPotConversion = false;
      dispatcher.fireEvent(eventDispatchers.FORCE_STOP_POT_CONVERSION);
    } else {
      if (ingenuity.configData.enableStageClick) {
        if (ingenuity.configData.isAutoplayActive) {
          dispatcher.fireEvent(SlotEventConstants.DISABLE_BUTTON, [SlotConstants.SpinBtnId]);
        }
        if (this.model.getIsBigWinRunning()) {
          dispatcher.fireEvent(SlotEventConstants.SUMUP_BIGWIN);
          dispatcher.fireEvent(SlotEventConstantsBehavior.CLEAR_BIG_WIN);
        }
        ingenuity.configData.enableStageClick = false;
      }
      if (ingenuity.configData.enableStageClickOnFirstToggle) {
        if (this.paylineView) {
          dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_SPAGETTI);
          dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_FRAMES);
          dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_WIN_PAYLINE);
          dispatcher.fireEvent(SlotEventConstants.STOP_METER_TICKUP);
          dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_SYMBOL_SOUND);
          ingenuity.soundManager.stop(this.model.getWinMeterTickUpSound());
        }
        dispatcher.fireEvent(SlotEventConstants.STOP_ALL_WIN_ANIMATIONS);
        dispatcher.off(SlotEventConstants.WIN_CYCLE_COMPLETED, this.onWinCycleCompleted);
        ingenuity.configData.stopWinAnimOnSecondToggle = true;
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_STAGE_CLICK_PLAYER_MSG);
        //Scenario fix- Below timer is added bcs the triggering animation was not playing when line win skipped during freegame trigger
        // Add some delay to call next win presentation after clearSymReel function call so that scatter trigger animation play after stage click
        delayedCall("nextWinPresentationDelay", 20, () => {
          killDelayedCall("nextWinPresentationDelay");
          dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        }, this);
        ingenuity.configData.enableStageClickOnFirstToggle = false;
        ingenuity.configData.stopWinAnimOnSecondToggle = false;
        dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
      }
    }
  }
}
